import { smoothScrollToEl } from "@theme/utilities";

function init() {
  const mbgAccordionDetails = document.querySelectorAll(
    ".product-information accordion-custom:last-of-type details",
  )[0];
  if (!mbgAccordionDetails) return;
  const mbgLinks = document.querySelectorAll(
    '.product-information a[href="#money-back-guarantee"]',
  );
  mbgLinks.forEach((mbgLink) => {
    mbgLink.addEventListener("click", (event) => {
      event.preventDefault();
      smoothScrollToEl(mbgAccordionDetails, 500);
      mbgAccordionDetails.setAttribute("open", "");
    });
  });
}
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", init);
} else {
  init();
}
